import {
  createError,
  defineNuxtRouteMiddleware,
  useAsyncData,
  useNuxtData,
} from '#imports'

import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'

import { PRODUCT_ROUTES } from '~/scopes/product-core/route-names'

export default defineNuxtRouteMiddleware(async function masterPP(to) {
  const { slug } = to.params
  const $httpFetch = useHttpFetch()

  const { data, error } = await useAsyncData(
    `MasterPP-${slug}`,
    async () => {
      if (
        to.name !== PRODUCT_ROUTES.MASTER_PRODUCT_PAGE &&
        to.name !== PRODUCT_ROUTES.DEV_ONLY_MASTER_PRODUCT_PAGE
      ) {
        return null
      }

      return $httpFetch('/product-page/parent-products/:slug', {
        pathParams: { slug: `${slug}` },
      })
    },
    {
      getCachedData: (key) => useNuxtData(key).data.value || undefined,
    },
  )

  if (error.value || !data.value?.productId) {
    throw createError({
      statusCode: error.value?.statusCode || 404,
      statusMessage: '[PRODUCT] Master PP Product id not found',
      fatal: true,
    })
  }
})
